import React from 'react';
import ContactForm from '../components/form';

function contactpage() {
  return (
    <div>
        <div className="uk-section bg-primary">
            <div className="uk-container">
                <h2 className='text-primary'>
                    We're Here to Help
                </h2>  
                <p className='text-secondary uk-text-center uk-visible@m'>
                Need help or have inquiries? Contact us via email at <a href="mailto:contactus@mystratos.co.in" className='text-primary' >contactus@mystratos.co.in</a> or give us a call at <a href="tel:7300674006" className='text-primary' >73006 74006.</a> Our support team is available Monday to Friday, from 10:00 AM to 05:30 PM. We're committed to delivering top-notch service and ensuring your satisfaction.
                </p>
                <p className='text-secondary uk-text-justify uk-hidden@m'>
                Need help or have inquiries? Contact us via email at <a href="mailto:contactus@mystratos.co.in" className='text-primary' >contactus@mystratos.co.in</a> or give us a call at <a href="tel:7300674006" className='text-primary' >73006 74006.</a> Our support team is available Monday to Friday, from 10:00 AM to 05:30 PM. We're committed to delivering top-notch service and ensuring your satisfaction.
                </p>
                <div className="">
                    <a href='tel:+917300674006'>
                        <button>
                            Call Us
                        </button>
                    </a>
                </div>
            </div>
        </div>
        <ContactForm/>
    </div>
  )
}

export default contactpage